/**
 * LexemesDrawer.js
 * Description: renders a button and an overlay containing Lexemes table if the button is clicked
 */

import { useRef, Fragment } from "react";
import { css } from "@emotion/react";

import Lexemes from "./Lexemes";

import {
  useDisclosure,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
} from "@chakra-ui/react";
export const LexemesDrawer = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <Fragment>
      <Button
        css={css`
          :hover {
            color: #172b3a;
            background-color: #fff;
            border-color: #172b3a;
          }
        `}
        ref={btnRef}
        bg="#172b3a"
        mr={5}
        border="1px"
        borderColor="white"
        onClick={onOpen}
      >
        LEXEMES
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="md"
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>LEXEMES</DrawerHeader>
            <DrawerBody>
              <Lexemes />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Fragment>
  );
};
